<template>
  <div>
    <p v-if="env === 'production'">Redirecting to login page...</p>
  </div>
</template>
<script>
import { Auth } from '@/api';

export default {
  name: 'app-login',
  data() {
    return {
      user: { email: '' },
    };
  },
  computed: {
    env() {
      return process.env.NODE_ENV;
    },
  },
  async mounted() {
    if (this.env === 'production') {
      const url = window.location.origin;
      const redirect = url + process.env.VUE_APP_VERIFY;
      window.location.href = `${url}/api/auth/initiatesinglesignon?returnUrl=${redirect}`;
    }

    if (this.env === 'development') {
      const { data } = await Auth.token();
      this.$router.push({ name: 'verify', query: { token: data.token } });
    }
  },
};
</script>
